import { Mail, Phone } from "lucide-react";
import Seo from "@/components/np/Seo";
import SectionHeading from "@/components/np/SectionHeading";
import ClinicCard from "@/components/clinics/ClinicCard";
import ContactForm from "@/components/clinics/ContactForm";
import { VERIFIED_LABEL, booking, clinics, meta, site } from "@/content";

export default function KlinikerBoka() {
  return (
    <>
      <Seo {...meta.kliniker} />
      <section className="page-hero" aria-labelledby="kb-title">
        <div className="container-np py-16 sm:py-20">
          <p className="eyebrow">Kliniker & boka</p>
          <h1 id="kb-title" className="mt-4 max-w-4xl font-serif text-5xl leading-[1.02] text-ink sm:text-6xl lg:text-7xl">Boka tid i Nacka eller Göteborg</h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted">Välj mottagning nedan. Du bokar via BokaDirekt, där du ser lediga tider, aktuella priser och får bokningsbekräftelse.</p>
          <div className="mt-12 grid gap-5 md:grid-cols-2">
            {clinics.map((c) => <ClinicCard key={c.id} clinic={c} showServices />)}
          </div>
          <p className="mt-5 text-sm text-muted">
            Priser enligt BokaDirekt, kontrollerade {VERIFIED_LABEL}. Aktuella priser visas alltid vid bokning.{" "}
            <a href={booking.profileUrl} target="_blank" rel="noopener noreferrer" className="font-medium text-pine underline underline-offset-4" data-testid="kb-profile-link">Se hela BokaDirekt-profilen</a>
          </p>
        </div>
      </section>
      <section className="bg-sand/60 py-16 sm:py-20 lg:py-24" aria-labelledby="contact-title">
        <div className="container-np grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading id="contact-title" eyebrow="Kontakt" title="Har du en fråga?" intro="Enklast är att boka direkt. Har du en praktisk fråga kan du ringa, mejla eller lämna ett kort meddelande så hör vi av oss." />
            <ul className="mt-8 space-y-3">
              <li><a href={site.phone.href} className="inline-flex items-center gap-3 text-lg font-medium text-ink hover:text-pine" data-testid="kb-phone-link"><Phone className="h-5 w-5 text-pine" aria-hidden="true" />{site.phone.display}</a></li>
              <li><a href={site.email.href} className="inline-flex items-center gap-3 text-lg font-medium text-ink hover:text-pine" data-testid="kb-email-link"><Mail className="h-5 w-5 text-pine" aria-hidden="true" />{site.email.display}</a></li>
            </ul>
          </div>
          <div className="lg:col-span-7"><ContactForm /></div>
        </div>
      </section>
    </>
  );
}
